var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentChildRelationshipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35355 0.646447C4.15829 0.451184 3.84171 0.451184 3.64645 0.646447L0.464466 3.82843C0.269204 4.02369 0.269204 4.34027 0.464466 4.53553C0.659728 4.7308 0.976311 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.7308 4.34027 7.7308 4.02369 7.53553 3.82843L4.35355 0.646447ZM4 1H3.5V24H4H4.5V1H4ZM8 28V28.5H20V28V27.5H8V28ZM4 24H3.5C3.5 26.4853 5.51472 28.5 8 28.5V28V27.5C6.067 27.5 4.5 25.933 4.5 24H4Z",
    fill: "#ABB1BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentChildRelationshipIcon);
export default __webpack_public_path__ + "static/media/parentChildRelationshipIcon.2200c4355ff408816ba1da981e3ce6ce.svg";
export { ForwardRef as ReactComponent };